
import ListComponent from "../../../components/events/Index.vue";

export default {
  components: {
    ListComponent
  }
}
